import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { OptionChips, autoPick, missingOption } from './OptionChips';

const expandUnits = (combo) =>
  (combo?.items || []).flatMap((it) => Array.from({ length: it.quantity || 1 }, () => it));

export const ComboPickerDialog = ({ combo, onClose, onConfirm }) => {
  const units = expandUnits(combo);
  const [sel, setSel] = useState([]);

  useEffect(() => {
    setSel(expandUnits(combo).map((u) => ({ size: autoPick(u.sizes), color: autoPick(u.colors) })));
  }, [combo]);

  const update = (idx, patch) => setSel((prev) => prev.map((s, i) => (i === idx ? { ...s, ...patch } : s)));

  const confirm = () => {
    for (let i = 0; i < units.length; i++) {
      const err = missingOption(units[i], sel[i]?.size, sel[i]?.color);
      if (err) { toast.error(`${err} (peça ${i + 1})`); return; }
    }
    onConfirm(units.map((u, i) => ({ product_id: u.product_id, product_name: u.product_name, size: sel[i]?.size || '', color: sel[i]?.color || '' })));
  };

  return (
    <Dialog open={!!combo} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-[480px] max-h-[90vh] overflow-y-auto bg-white" data-testid="combo-picker-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Outfit'] text-xl">{combo?.name}</DialogTitle>
          <p className="text-sm text-[#73706A]">Escolha o tamanho e a cor de cada peça do combo.</p>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          {units.map((u, i) => (
            <div key={i} className="p-3 rounded-lg border border-[#E6E2D8] bg-[#FDFBF7] space-y-2.5" data-testid={`combo-picker-unit-${i}`}>
              <p className="text-sm font-semibold text-[#1A1A1A]">Peça {i + 1}: {u.product_name}</p>
              {u.sizes?.length > 0 && (
                <OptionChips label="Tamanho" options={u.sizes} value={sel[i]?.size} onChange={(v) => update(i, { size: v })} testid={`combo-picker-size-${i}`} />
              )}
              {u.colors?.length > 0 && (
                <OptionChips label="Cor" options={u.colors} value={sel[i]?.color} onChange={(v) => update(i, { color: v })} testid={`combo-picker-color-${i}`} />
              )}
              {!u.sizes?.length && !u.colors?.length && <p className="text-xs text-[#73706A]">Sem opções de tamanho/cor.</p>}
            </div>
          ))}
        </div>
        <DialogFooter className="mt-3">
          <Button variant="outline" onClick={onClose} data-testid="combo-picker-cancel">Cancelar</Button>
          <Button className="bg-[#E85D04] hover:bg-[#DC2F02] text-white" onClick={confirm} data-testid="combo-picker-confirm">
            Adicionar ao carrinho — $ {(combo?.price || 0).toFixed(2)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
